// extracted by mini-css-extract-plugin
export default {"PostCreate":"qk_a bht_qt bht_a bht_w bht_ea"};